import { NgModule } from '@angular/core';
import { SymptomWidget } from './symptom-widget/symptom-widget';
import { CommonModule } from '@angular/common';
import { EvidenceWidget } from './evidence-widget/evidence-widget';
import { BPWidget } from './bp-widget/bp-widget';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TreatmentWidget } from './treatment-widget/treatment-widget';


@NgModule({
  declarations: [
    SymptomWidget,
    EvidenceWidget,
    TreatmentWidget,
    BPWidget
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
    SymptomWidget,
    EvidenceWidget,
    TreatmentWidget,
    BPWidget
  ],
})
export class LoggingWidgetModule {}
